import { isEmpty } from 'ramda';

const updateDataLayer = (taggingData) => {
  if (window.digitalData) {
    window.digitalData = Object.assign({}, window.digitalData, taggingData);
  }
};

export const fireDTMEvent = (taggingData, trackingTag='CONTROLLER') => {
  if (!taggingData || isEmpty(taggingData)) throw TypeError('Missing taggingData');
  updateDataLayer(taggingData);
  if (window._satellite) {
    window._satellite.track(trackingTag);
  }
};

export const updateDTMEvent = (taggingData) => {
  if (!taggingData || isEmpty(taggingData)) throw TypeError('Missing taggingData');
  updateDataLayer(taggingData);
};



